// ResetPassword.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../axios/axios";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      await axios.post("/auth/reset-password", {
        email,
        newPassword,
      });

      setMessage("Password reset successful.");
      navigate("/login");
    } catch (error) {
      setMessage(error.response?.data?.message || "Reset failed.");
    }
  };

  return (
    <div
      className=" d-flex flex-column justify-content-center"
      style={{ height: "100vh" }}
    >
      <h2 className="fw-bold text-center mb-5">Reset Password</h2>
      <form onSubmit={handleReset} className="w-50 container">
        <input
          className="form-control shadow-none mb-4"
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <input
          className="form-control shadow-none mb-4"
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit" className="btn bg_maincolor text-white ">
          Reset Password
        </button>
      </form>
      <p>{message}</p>
    </div>
  );
};

export default ResetPassword;
